import { Box, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.background.general,
      gap: '0px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 72px)',
    height: 'auto',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('laptop')]: {
      gap: '10px',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px 32px 16px',
      gap: '32px',
    },
  };
});

export const Box404 = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '420px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'max-content',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },

    h1: {
      color: 'white',
      fontWeight: 800,
      fontSize: '192px',
      lineHeight: '100%',
      letterSpacing: '-2%',
      marginBottom: '16px',

      [theme.breakpoints.down('tablet')]: {
        fontSize: '128px',
      },
    },

    h4: {
      color: '#2B163F',
      fontWeight: 700,
      fontSize: '32px',
      lineHeight: '120%',
      marginBottom: '8px',
    },

    p: {
      color: '#444444',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '136%',
      textAlign: 'center',
    },

    '> button': {
      maxWidth: '243px',
      marginTop: '24px',
    },

    /* [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('laptop')]: {
      gap: '10px',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px 32px 16px',
      gap: '32px',
    }, */
  };
});
